import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store/index'

Vue.use(VueRouter)

const publicRoutes = [
  {
    path: '/',
    name: 'home',
    component: () => import(/* webpackChunkName: "home" */ '../views/Home.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: () =>
      import(/* webpackChunkName: "login" */ '../views/Login.vue')
  },
  {
    path: '/redefinir',
    name: 'redefinir',
    component: () =>
      import(/* webpackChunkName: "reset" */ '../views/Reset.vue')
  },
  {
    path: '/redefinir/:email',
    name: 'newPassword',
    props: true,
    component: () =>
      import(
        /* webpackChunkName: "newPassword" */
        '../views/redirects/NewPassword.vue'
      )
  },
  {
    path: '/nova_conta',
    name: 'NovaConta',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "register" */ '../views/NewLogin.vue')
  },
  {
    path: '/nova_conta/:tipo',
    name: 'NovaConta',
    props: true,
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "register" */ '../views/NewLogin.vue')
  },
  {
    path: '/profissional/:id',
    name: 'professionaldetail',
    props: true,
    component: () =>
      import(
        /* webpackChunkName: "professionalscheduled" */
        '../views/ProfessionalDetail.vue'
      )
  },
  {
    path: '/confirmar/:id/:token',
    name: 'confirm',
    props: true,
    component: () =>
      import(
        /* webpackChunkName: "confirm" */
        '../views/redirects/ConfirmRegistration.vue'
      )
  },
  {
    path: '/sobre',
    name: 'about',
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/faq',
    name: 'faq',
    component: () => import(/* webpackChunkName: "faq" */ '../views/FAQ.vue')
  },
  {
    path: '/vantagens',
    name: 'benefits',
    component: () =>
      import(/* webpackChunkName: "benefits" */ '../views/Benefits.vue')
  },
  {
    path: '/contato',
    name: 'contact',
    component: () =>
      import(/* webpackChunkName: "contact" */ '../views/ContactUs.vue')
  },
  {
    path: '/contatoEmpresa',
    name: 'contactCompany',
    component: () =>
      import(/* webpackChunkName: "contact" */ '../views/ContactUsCompany.vue')
  },
  {
    path: '/services',
    name: 'services',
    component: () =>
      import(/* webpackChunkName: "services" */ '../views/Services.vue')
  },
  {
    path: '/signin',
    name: 'signin',
    component: () =>
      import(/* webpackChunkName: "signin" */ '../views/LoginMode.vue')
  },
  {
    path: '/saibamais/',
    name: 'learnmore',
    component: () =>
      import(/* webpackChunkName: "learnmore" */ '../views/LearnMore.vue')
  },
  {
    path: '/saibamais/:idx',
    name: 'learnmoreIdx',
    props: true,
    component: () =>
      import(/* webpackChunkName: "learnmore" */ '../views/LearnMore.vue')
  },
  {
    path: '/agendamento',
    name: 'scheduling',
    component: () =>
      import(/* webpackChunkName: "Scheduling" */ '../views/Scheduling.vue'),
    meta: {
      title: 'Agendamento InstaCares'
    }
  },
  {
    path: '/passwordreset',
    name: 'passwordreset',
    component: () =>
      import(
        /* webpackChunkName: "passwordreset" */
        '../views/PerfilPasswordReset.vue'
      )
  }
]

const internalRoutes = [
  {
    path: '/verificar_perfil',
    name: 'perfilController',
    component: () =>
      import(
        /* webpackChunkName: "newperfil" */
        '../views/PerfilController.vue'
      ),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/registro',
    name: 'registro',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "register" */ '../views/Register.vue')
  },
  {
    path: '/registro/:typeProp',
    name: 'registro',
    props: true,
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "register" */ '../views/Register.vue')
  },
  {
    path: '/novoperfil',
    name: 'newperfil',
    component: () =>
      import(
        /* webpackChunkName: "newperfil" */
        '../views/registers/NewPerfil.vue'
      ),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/selecionarperfil',
    name: 'selectperfil',
    meta: {
      requiresAuth: true
    },
    component: () =>
      import(/* webpackChunkName: "selectperfil" */ '../views/PerfilSelect.vue')
  },
  {
    path: '/inicio',
    name: 'dashboard',
    meta: {
      requiresAuth: true,
      requiresPerfil: true
    },
    component: () =>
      import(/* webpackChunkName: "dashboard" */ '../views/Dashboard.vue')
  },
  {
    path: '/mensagens',
    name: 'messageslist',
    meta: {
      requiresAuth: true,
      requiresPerfil: true
    },
    component: () =>
      import(
        /* webpackChunkName: "messages" */
        '../views/MessagesList.vue'
      )
  },
  {
    path: '/mensagem/:idreceiver/:idagendamento',
    name: 'messagesdetail',
    meta: {
      requiresAuth: true,
      requiresPerfil: true
    },
    props: true,
    component: () =>
      import(
        /* webpackChunkName: "messages" */
        '../views/MessageDetail.vue'
      )
  },
  {
    path: '/perfil',
    name: 'perfil',
    meta: {
      requiresAuth: true,
      requiresPerfil: true
    },
    component: () =>
      import(/* webpackChunkName: "perfil" */ '../views/Perfil.vue')
  },
  {
    path: '/agendamentos_realizados',
    name: 'attendance',
    meta: {
      requiresAuth: true,
      requiresPerfil: true
    },
    component: () =>
      import(
        /* webpackChunkName: "contact" */

        '../views/Attendance.vue'
      )
  },
  {
    path: '/prontuario/:idPacote',
    meta: {
      requiresAuth: true,
      requiresPerfil: true
    },
    name: 'record',
    props: true,
    component: () =>
      import(/* webpackChunkName: "record" */ '../views/Record.vue')
  },
  {
    path: '/avaliacao/:idpacote/:idagendamento',
    name: 'userrating',
    meta: {
      requiresAuth: true,
      requiresPerfil: true
    },
    props: true,
    component: () =>
      import(
        /* webpackChunkName: "userrating" */

        '../views/UserRating.vue'
      )
  },
  /*{
    path: "/attendancemedical",
    name: "attendancemedical",
    meta: {
      requiresAuth: true,
      requiresPerfil: true
    },
    component: () =>
      import(
        /* webpackChunkName: "attendancemedical" ./ "../views/AttendanceMedical.vue"
      )
  },*/
  {
    path: '/atendimentos_agendados',
    name: 'scheduled',
    meta: {
      requiresAuth: true,
      requiresPerfil: true
    },
    component: () =>
      import(
        /* webpackChunkName: "scheduled" */
        '../views/Scheduled.vue'
      )
  },
  /*{
    path: "/professionalscheduled/:id",
    name: "professionalscheduled",
    meta: {
      requiresAuth: true,
      requiresPerfil: true
    },
    props: true,
    component: () =>
      import(
        /* webpackChunkName: "professionalscheduled" /
        "../views/ProfessionalScheduled.vue"
      )
  },
  {
    path: "/personalinformation",
    name: "personalinformation",
    meta: {
      requiresAuth: true,
      requiresPerfil: true
    },
    component: () =>
      import(
        /* webpackChunkName: "personalinformation" /
        "../views/PersonalInformation.vue"
      )
  },
  {
    path: "/sessionresume",
    name: "sessionresume",
    meta: {
      requiresAuth: true,
      requiresPerfil: true
    },
    component: () =>
      import(
        /* webpackChunkName: "sessionresume" / "../views/SessionResume.vue"
      )
  },
  */
  {
    path: '/valepresente',
    name: 'valepresente',
    meta: {
      requiresAuth: true,
      requiresPerfil: true
    },
    component: () =>
      import(
        /* webpackChunkName: "sessionresume" */ '../views/gift/GiftPurchase.vue'
      )
  }
]
const clientRoutes = [
  {
    path: '/armazenamento',
    name: 'storage',
    meta: {
      requiresAuth: true,
      requiresPerfil: true,
      user_type: 'cliente'
    },
    component: () =>
      import(/* webpackChunkName: "storage" */ '../views/Storage.vue')
  },
  {
    path: '/enviar_arquivo',
    name: 'uploadfile',
    meta: {
      requiresAuth: true,
      requiresPerfil: true,
      user_type: 'cliente'
    },
    component: () =>
      import(/* webpackChunkName: "uploadfile" */ '../views/UploadFile.vue')
  }
]

const professionalRoutes = [
  {
    path: '/informacao_atendimento',
    name: 'operation',
    meta: {
      requiresAuth: true,
      requiresPerfil: true,
      user_type: 'profissional'
    },
    component: () =>
      import(/* webpackChunkName: "operation" */ '../views/Operation.vue')
  },
  {
    path: '/regiao_atendimento',
    name: 'servicesaddress',
    meta: {
      requiresAuth: true,
      requiresPerfil: true,
      user_type: 'profissional'
    },
    component: () =>
      import(/* webpackChunkName: "servicesaddress" */ '../views/Regions.vue')
  },
  {
    path: '/definir_servicos',
    name: 'appointservices',
    meta: {
      requiresAuth: true,
      requiresPerfil: true,
      user_type: 'profissional'
    },
    component: () =>
      import(
        /* webpackChunkName: "appointservices" */ '../views/AppointServices.vue'
      )
  },
  {
    path: '/agenda',
    name: 'agenda',
    meta: {
      requiresAuth: true,
      requiresPerfil: true,
      user_type: 'profissional'
    },
    component: () =>
      import(/* webpackChunkName: "agenda" */ '../views/DaySpan.vue')
  },
  {
    path: '/servicos_realizados',
    name: 'servicesperformed',
    meta: {
      requiresAuth: true,
      requiresPerfil: true
    },
    component: () =>
      import(
        /* webpackChunkName: "servicesperformed" */ '../views/ServicesPerformed.vue'
      )
  },
  {
    path: '/prontuarios_pendentes',
    name: 'pending',
    meta: {
      requiresAuth: true,
      requiresPerfil: true
    },
    component: () =>
      import(
        /* webpackChunkName: "pendingrecord" */
        '../views/PendingRecords.vue'
      )
  }
]

const adminRoutes = [
  /** ADMIN AREA ROUTERS */
  {
    path: '/admin/login',
    name: 'loginAdmin',
    /* meta: {
      requiresAuth: true,
      is_admin: true
    }, */
    component: () =>
      import(
        /* webpackChunkName: "loginAdmin" */
        '../views/admin/Login.vue'
      )
  },
  /*{
    path: "/admin/charts",
    name: "chartsAdmin",
    meta: {
      requiresAuth: true,
      is_admin: true
    },
    component: () =>
      import(
        /* webpackChunkName: "chartsAdmin" /
        "../views/admin/Charts.vue"
      )
  },*/
  {
    path: '/admin/services',
    name: 'admservices',
    meta: {
      requiresAuth: false,
      is_admin: true
    },
    component: () =>
      import(
        /* webpackChunkName: "admservices" */
        '../views/admin/Services.vue'
      )
  },
  {
    path: '/admin/agendamentos',
    name: 'admagendamentos',
    meta: {
      requiresAuth: false,
      is_admin: true
    },
    component: () =>
      import(
        /* webpackChunkName: "admagendamentos" */
        '../views/admin/SchedulingsList.vue'
      )
  },
  {
    path: '/admin/usuarios',
    name: 'admusers',
    meta: {
      requiresAuth: false,
      is_admin: true
    },
    component: () =>
      import(
        /* webpackChunkName: "admusers" */
        '../views/admin/Users.vue'
      )
  },
  {
    path: '/admin/perfis',
    name: 'admperfis',
    meta: {
      requiresAuth: false,
      is_admin: true
    },
    component: () =>
      import(
        /* webpackChunkName: "admperfis" */
        '../views/admin/PerfilList.vue'
      )
  },
  {
    path: '/admin/uploadeula',
    name: 'uploadeula',
    meta: {
      requiresAuth: false,
      is_admin: true
    },
    component: () =>
      import(
        /* webpackChunkName: "uploadeula" */
        '../views/admin/UploadEULA.vue'
      )
  },
  {
    path: '/admin/cupom',
    name: 'admcupom',
    meta: {
      requiresAuth: false,
      is_admin: true
    },
    component: () =>
      import(
        /* webpackChunkName: "admcupom" */
        '../views/admin/CupomController.vue'
      )
  }
  /** FIM DO ADMIN AREA ROUTERS */
]
const routes = [
  ...publicRoutes,
  ...internalRoutes,
  ...clientRoutes,
  ...professionalRoutes,
  ...adminRoutes,
  {
    path: '/teste',
    name: 'teste',
    component: () =>
      import(/* webpackChunkName: "teste" */ '../views/Teste.vue')
  },
  //LAST ROUNT - se for cadastrar alguma, cadastre acima dessa.
  {
    path: '*',
    redirect: '/'
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.VUE_APP_BASE_ROUTE || '/',
  routes
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // Páginas requerem autenticação
    store
      .dispatch('checkUserStatus')
      .then(user => {
        // Usuário Logado
        user.getIdToken(true).then(function(idToken) {
          store.commit('updateToken', idToken)
        })
        let tipo_user = store.getters.getUserType
        let perfilSelected = store.getters.getPerfil
        // Páginas NÃO Administrativas
        if (to.matched.some(record => record.meta.requiresPerfil)) {
          // Páginas que requerem um perfil selecionado:
          if (perfilSelected) {
            // Há um perfil selecionado
            if (to.matched.some(record => record.meta.user_type)) {
              // Requer um tipo de usuario especifico
              if (
                to.matched.some(record => record.meta.user_type === tipo_user)
              )
                next()
              // Tipo de usuário bate
              else
                next({
                  name: 'dashboard'
                }) // Usuário não bate
            } else next() // Não requer um tipo de usuario especifico
          }
          // Não há um perfil selecionado
          else
            store.getters.getAccountType === 'profissional'
              ? next({
                  name: 'signin'
                })
              : next({
                  name: 'selectperfil'
                })
        } else next() // Pagina não requer um perfil
      })
      .catch(() => {
        // Usuário Não Logado
        next({
          path: '/login',
          params: {
            nextUrl: to.fullPath
          }
        })
      })
  }
  // Páginas ADMINISTRATIVAS
  else if (to.matched.some(record => record.meta.is_admin)) {
    console.log('Entrando em area restrita')
    if (store.getters.getAdminAuthentication.token) {
      console.log('Admin autenticado!')
      // Usuário é ADMIN
      next()
    } else {
      // Usuário não é admin
      next({
        name: 'loginAdmin'
      })
    }
  }
  // Páginas que NÃO requerem autenticação
  else {
    next()
  }
})

export default router
